import {
  IMobilityOptionCategoryState,
  IMobilityOptionObject,
  IMobilityOptionSearchState,
  IMobilityOptionState
} from '../../../types'
import {
  IMobilityOptionsAction,
  IMobilityOptionsCategoryAction,
  IMobilityOptionsCategoryCreateSuccess,
  IMobilityOptionsCategoryListSuccess,
  IMobilityOptionsCategoryRemoveRequest,
  IMobilityOptionsCreateSuccess,
  IMobilityOptionsListSuccess,
  IMobilityOptionsSearchSuccess,
  IMobilityOptionsUpdateSuccess,
  IMobilityOptionsRemoveSuccess
} from '../../actions/mobility-options'
import {
  CLEAR_MOBILITY_OPTIONS_SEARCH,
  MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS,
  MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS,
  MOBILITY_OPTIONS_CREATE_FAILURE,
  MOBILITY_OPTIONS_CREATE_REQUEST,
  MOBILITY_OPTIONS_CREATE_SUCCESS,
  MOBILITY_OPTIONS_LIST_FAIL,
  MOBILITY_OPTIONS_LIST_REQUEST,
  MOBILITY_OPTIONS_LIST_SUCCESS,
  MOBILITY_OPTIONS_SEARCH_FAILURE,
  MOBILITY_OPTIONS_SEARCH_REQUEST,
  MOBILITY_OPTIONS_SEARCH_SUCCESS,
  MOBILITY_OPTIONS_UPDATE_REQUEST,
  MOBILITY_OPTIONS_UPDATE_SUCCESS,
  MOBILITY_OPTIONS_UPDATE_FAILURE,
  MOBILITY_OPTIONS_REMOVE_REQUEST,
  MOBILITY_OPTIONS_REMOVE_SUCCESS,
  MOBILITY_OPTIONS_REMOVE_FAILURE
} from '../../constants/'

const initialState: IMobilityOptionState = {
  isFetching: false,
  items: {},
  lastUpdated: Date.now()
}

const initialSearchState: IMobilityOptionSearchState = {
  isFetching: false,
  items: [],
  query: ''
}

const initialCategoryState: IMobilityOptionCategoryState = {
  isFetching: false,
  items: {},
  lastUpdated: Date.now()
}

export function mobilityOptions(state: IMobilityOptionState, action: IMobilityOptionsAction): IMobilityOptionState {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case MOBILITY_OPTIONS_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IMobilityOptionsListSuccess).mobilityOptions,
        lastUpdated: Date.now()
      })

    case MOBILITY_OPTIONS_LIST_FAIL:
      return Object.assign({}, state, {
        isFetching: false
      })
    case MOBILITY_OPTIONS_CREATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_CREATE_SUCCESS: {
      const opt: IMobilityOptionObject = (action as IMobilityOptionsCreateSuccess).option
      const obj = Object.assign({}, state.items)
      obj[opt.id] = opt
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case MOBILITY_OPTIONS_CREATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case MOBILITY_OPTIONS_UPDATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_UPDATE_SUCCESS: {
      const opt: IMobilityOptionObject = (action as IMobilityOptionsUpdateSuccess).option
      const obj = Object.assign({}, state.items)
      if (obj[opt.id]) {
        delete obj[opt.id]
      }
      obj[opt.id] = opt
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case MOBILITY_OPTIONS_UPDATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case MOBILITY_OPTIONS_REMOVE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_REMOVE_SUCCESS: {
      const opt: IMobilityOptionObject = (action as IMobilityOptionsRemoveSuccess).option
      const obj = Object.assign({}, state.items)
      if (obj[opt.id]) {
        delete obj[opt.id]
      }
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case MOBILITY_OPTIONS_REMOVE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
  }
  return state
}

export function mobilityOptionsSearch(state: IMobilityOptionSearchState, action: any): IMobilityOptionSearchState {
  if (typeof state === 'undefined') {
    return initialSearchState
  }
  switch (action.type) {
    case MOBILITY_OPTIONS_SEARCH_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        query: action.query
      })
    case MOBILITY_OPTIONS_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IMobilityOptionsSearchSuccess).mobilityOptions
      })
    case MOBILITY_OPTIONS_SEARCH_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    case CLEAR_MOBILITY_OPTIONS_SEARCH:
      return Object.assign({}, state, {
        items: []
      })
  }
  return state
}

export function mobilityOptionsCategories(
  state: IMobilityOptionCategoryState,
  action: IMobilityOptionsCategoryAction
): IMobilityOptionCategoryState {
  if (typeof state === 'undefined') {
    return initialCategoryState
  }
  switch (action.type) {
    // LIST
    case MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IMobilityOptionsCategoryListSuccess).categories,
        lastUpdated: Date.now()
      })
    case MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    // CREATE
    case MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS: {
      const name = (action as IMobilityOptionsCategoryCreateSuccess).category.name
      const obj = Object.assign({}, state.items)
      const id = new Date().getTime().toString()
      obj[id] = { id, name }
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    // REMOVE
    case MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST: {
      const id = (action as IMobilityOptionsCategoryRemoveRequest).id
      const arr = Object.assign({}, state.items)
      delete arr[id]
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: arr
      })
      return copy
    }
    case MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false
      })
    case MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/mobility-options/index.ts